import { createSelector } from 'reselect';
import { StoreState } from 'store/types';
import { VatState } from './types';

const selectSignUp = (app: StoreState): VatState => app.vat;

export const getVatLoading = createSelector(
  selectSignUp,
  (returns: VatState): VatState['loading'] => returns.loading
);

export const getVatPrepLoading = createSelector(
  selectSignUp,
  (returns: VatState): VatState['prepLoading'] => returns.prepLoading
);

export const getVatReturnLogs = createSelector(
  selectSignUp,
  (returns: VatState): VatState['vatReturnLogs'] => returns.vatReturnLogs
);

export const getVatRunData = createSelector(
  selectSignUp,
  (returns: VatState): VatState['vatRunData'] => returns.vatRunData
);

export const getVatReportData = createSelector(
  selectSignUp,
  (returns: VatState): VatState['vatReportData'] => returns.vatReportData
);

export const getVatReconciliation = createSelector(
  selectSignUp,
  (returns: VatState): VatState['reconciliation'] => returns.reconciliation
);

export const getReconciliationRun = createSelector(
  selectSignUp,
  (returns: VatState): VatState['reconciliationRun'] =>
    returns.reconciliationRun
);

export const getVatActivityLogs = createSelector(
  selectSignUp,
  (returns: VatState): VatState['activityLogs'] => returns.activityLogs
);

export const getVatSuccess = createSelector(
  selectSignUp,
  (returns: VatState): VatState['success'] => returns.success
);

export const getExcelFileData = createSelector(
  selectSignUp,
  (returns: VatState): VatState['excelFileData'] => returns.excelFileData
);

export const getUpdateFromPage = createSelector(
  selectSignUp,
  (returns: VatState): VatState['updateFromPage'] => returns.updateFromPage
);
export const getVatNoDataFound = createSelector(
  selectSignUp,
  (returns: VatState): VatState['noDataFound'] => returns.noDataFound
);

export const getReportFilters = createSelector(
  selectSignUp,
  (returns: VatState): VatState['reportFilters'] => returns.reportFilters
);
export const getVatAttachmentLoading = createSelector(
  selectSignUp,
  (returns: VatState): VatState['attachmentLoading'] =>
    returns.attachmentLoading
);

export const getLastFetchedTransactionAttachments = createSelector(
  selectSignUp,
  (returns: VatState) => returns.lastFetchedTransactionAttachments
);

export const getMetadataAttachmentLoading = createSelector(
  selectSignUp,
  (returns: VatState): VatState['metadataAttachmentLoading'] =>
    returns.metadataAttachmentLoading
);

export const getLastFetchedMetadataAttachments = createSelector(
  selectSignUp,
  (returns: VatState) => returns.lastFetchedMetadataAttachments
);

export const getExcelLoadingState = createSelector(
  selectSignUp,
  (returns: VatState): boolean => returns.loadingState.excelLoading
);

export const getCsvLoadingState = createSelector(
  selectSignUp,
  (returns: VatState): boolean => returns.loadingState.csvLoading
);

export const getVatBackendError = createSelector(
  selectSignUp,
  (returns: VatState): boolean => returns.backendError
);
export const VAT_ATTACHMENT_LOADING = 'vat/attachment-loading';
